import { Routes } from "@angular/router";
import { AcuerdoMrbListComponent } from "./acuerdo/acuerdo-mrb/acuerdo-mrb.component";
import { TableDespachoComponent } from "./despacho/table-despacho/table-despacho.component";
import { MoverDespachoComponent } from "./despacho/mover-despacho/mover-despacho.component";
import { MoverAcuerdoComponent } from "./acuerdo/mover-acuerdo/mover-acuerdo.component";

export const formasEnvio: Routes = [
  {
    path: "acuerdos-mrb-listado",
    component: AcuerdoMrbListComponent,
  },
  {
    path: "despacho/listado",
    component: TableDespachoComponent,
  },
  {
    path: "mover/despacho/:id_tema",
    component: MoverDespachoComponent,
  },
  {
    path: "mover/mrb/:id_tema",
    component: MoverAcuerdoComponent,
  },
];
